import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
  return request({
    url: "/base/storage/findByPage",
    method: "post",
    data
  });
}
/**
 * 保存仓库信息
 * @param {*} data
 */
export function SaveStorageInfo(data) {
  return request({
    headers: { type: "json" },
    url: "/base/storage/saveStorageInfo",
    method: "post",
    data
  });
}
/**
 * 删除仓库信息
 * @param {*} data
 */
export function DeleteStorageInfoByIds(data) {
  return request({
    url: "/base/storage/deleteStorageInfoByIds",
    method: "post",
    data
  });
}
/**
 * 查找仓库信息
 * @param {*} data
 */
export function FindStorageInfoById(data) {
  return request({
    url: "/base/storage/findStorageInfoById",
    method: "post",
    data
  });
}
